/*if (!!document.querySelector('.ia-block-publications__filters')) {
    document.querySelectorAll('.ia-block-publications__filters').forEach((block) => {
        const submitButton = block.querySelector('[type="submit"]')
        const resetButton = block.querySelector('.js-ia-block-filters-reset')
        let timer

        block.querySelector('#publications_filter_type, #publications_filter_annee, #publications_filter_langue').addEventListener('focus', (e) => {
            window.clearTimeout(timer)
        })

        block.querySelector('#publications_filter_type').addEventListener('change', (e) => {
            window.clearTimeout(timer)
            timer = window.setTimeout(() => {
                submitButton.click()
            }, 1000)
        })

        block.querySelector('#publications_filter_annee').addEventListener('change', (e) => {
            window.clearTimeout(timer)
            timer = window.setTimeout(() => {
                submitButton.click()
            }, 1000)
        })

        block.querySelector('#publications_filter_langue').addEventListener('change', (e) => {
            window.clearTimeout(timer)
            timer = window.setTimeout(() => {
                submitButton.click()
            }, 1000)
        })

        if (resetButton) {
            resetButton.addEventListener('click', (e) => {
                block.querySelector('#publications_filter_type').value = ""
                block.querySelector('#publications_filter_annee').value = ""
                block.querySelector('#publications_filter_langue').value = ""
            })
        }
    })
}*/


jQuery(document).ready(function($) {
    // Gérer le clic sur l'ensemble de l'élément <h3> contenant l'année et le chevron
    $('.ia-block-publications__year').on('click', function(e) {
        e.preventDefault();

        var year = $(this).data('year');

        $('ul[data-year="' + year + '"]').slideToggle();
        $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
    });
});
